import PropTypes from 'prop-types';
import React from 'react';

import './ModalHeader.scss';

const ModalHeader = ({ underlineColor = 'black', header }) => {
  return (
    <div className={`modal-header--container-${underlineColor}`}>
      <span className={'modal-header-content'}>{header}</span>
    </div>
  );
};

ModalHeader.propTypes = {
  header: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  underlineColor: PropTypes.oneOf(['blue', 'green', 'black', 'red']),
};

export default ModalHeader;
